import React, { useCallback, useEffect, useState } from "react";
import {
  UseFormRegister,
  FieldErrors,
  UseFormClearErrors,
} from "react-hook-form";
import { Link } from "react-router-dom";
import SourceOfInfoDropDown from "../../components/SourceOfInfoDropDown";
import useDebounce from "../../lib/utils";

interface StoreInfo {
  numberOfStores: string;
  soucreOfInformation: string;
  serviceTypeId: string;
}
interface Service {
  name: string;
  serviceTypeId: number;
}
interface StoreInfoProps {
  register: UseFormRegister<StoreInfo>;
  errors: FieldErrors<StoreInfo>;
  clearErrors: UseFormClearErrors<StoreInfo>;
  onSourceOfInfoChange: (sourceInfo: string) => void;
  setValue: any;
  sourceOfInfo: string;
  onServiceTypeChange: (serviceTypeId: number) => void;
  ServiceTypeDropdownComponent: React.ReactNode;
}

const StoreInformation: React.FC<StoreInfoProps> = ({
  register,
  errors,
  clearErrors,
  onSourceOfInfoChange,
  setValue,
  sourceOfInfo,
  onServiceTypeChange,
  ServiceTypeDropdownComponent,
}) => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 1600);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setValue("numberOfStores", "1");
  }, [setValue]);

  const handleInputChange = (fieldPath: string) => {
    clearErrors(fieldPath as keyof StoreInfo);
  };

  const handleSourceOfInfoChange = (sourceOfInfo: string) => {
    setValue("soucreOfInformation", sourceOfInfo);
    onSourceOfInfoChange(sourceOfInfo);
    handleInputChange("soucreOfInformation");
  };

  return (
    <div className="xxl:space-y-6 space-y-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="xxxl:text-2xl xxl:text-xl text-lg font-semibold text-black">
          About Store
        </h2>
        <span className="text-sm font-medium text-customGrayBase">
          Step 3/3
        </span>
      </div>
      <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
        <div className="md:col-span-1 col-span-2">
          <label className="block xxl:text-sm text-xs font-semibold text-customGrayDark mb-1">
            Service Type<span className="text-red-500">*</span>
          </label>
          <div>
            {React.cloneElement(
              ServiceTypeDropdownComponent as React.ReactElement,
              {
                className: `${
                  isSmallScreen ? "h-[42px]" : "h-[50px]"
                } px-2 py-2 w-full flex border-nonejustify-between items-center`,

                dropdownMenuContentWidth:
                  window.innerWidth >= 1024 ? "w-[18vw]" : "",
              }
            )}
          </div>
          {errors?.serviceTypeId && (
            <p className="text-red-600 text-sm">
              {errors?.serviceTypeId?.message}
            </p>
          )}
        </div>
        <div className="md:col-span-1 col-span-2">
          <label className="block xxl:text-sm text-xs font-semibold text-customGrayDark text-nowrap">
            How did you hear about us?
          </label>
          <SourceOfInfoDropDown
            infoSource={sourceOfInfo}
            setInfoSource={handleSourceOfInfoChange}
          />

          {/*
          dont remove it hide yousaf bhai 

           <label className="block xxl:text-sm text-xs font-semibold text-customGrayDark text-nowrap">
            Number of store Location<span className="text-red-500">*</span>
          </label>
          <input
            autoComplete="new-password"
            className="mt-1 block w-full px-2 xxl:py-3 py-2 border border-gray-300 focus:border-customGreenColor focus:outline-customGreenColor rounded-lg"
            type="number"
            min="1"
            {...register("numberOfStores", {
              required: "This field is required",
            })}
            onChange={() => handleInputChange("numberOfStores")}
          />
          {errors?.numberOfStores && (
            <p className="text-red-600 text-sm">
              {errors?.numberOfStores?.message}
            </p>
          )} */}
        </div>
        {/* <div className="col-span-2">
          <label className="block xxl:text-sm text-xs font-semibold text-customGrayDark">
            How did you hear about us?
          </label>
          <SourceOfInfoDropDown
            infoSource={sourceOfInfo}
            setInfoSource={handleSourceOfInfoChange}
          />
        </div> */}
        <p className="col-span-2 text-xs font-normal text-customNeutralGray pt-1 pb-8">
          By signing up, you agree to the{" "}
          <Link
            target="_self"
            to="/terms-of-use"
            className="font-helveticaBold underline text-customGreenColor"
          >
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link
            to="/privacy-policy"
            target="_self"
            className="font-helveticaBold underline text-customGreenColor"
          >
            Privacy Policy
          </Link>
          , including{" "}
          <Link
            to="/cookie-use"
            target="_self"
            className="font-helveticaBold underline text-customGreenColor"
          >
            cookie use.
          </Link>
        </p>
      </div>
    </div>
  );
};

export default StoreInformation;
